import { useEffect, useState } from 'react';
import { getVenueList } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export const useVenueList = (
  excludeFromLoading = false,
  practiceAreaId = '',
  options = {},
  loadFullList = true,
  limit = 15,
  venueValue = '',
  isLandingPage = false
) => {
  const [venueOptions, setVenueOptions] = useState([]);
  const [isVenueLoading, setIsVenueLoading] = useState(false);

  const loadVenue = (practiceAreaId = '') => {
    setIsVenueLoading(true);
    if (loadFullList) {
      totalCountEvent('venue', '', '', '', '', excludeFromLoading)
        .then((response) => {
          getVenueList(response.data, '', 'forward', excludeFromLoading, 'alphabet_ascending', practiceAreaId, venueValue)
            .then((response) => {
              setVenueOptions(response?.data?.venues);
            })
            .catch((err) => {})
            .finally(() => setIsVenueLoading(false));
        })
        .catch((err) => {
          setIsVenueLoading(false);
          console.log(err);
        });
    } else {
      getVenueList(limit, '', 'forward', excludeFromLoading, 'alphabet_ascending', practiceAreaId, venueValue)
        .then((response) => {
          setVenueOptions(response?.data?.venues);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setIsVenueLoading(false));
    }
  };

  useEffect(() => {
    loadVenue(practiceAreaId);
  }, []);

  return { venueOptions, loadVenue, isVenueLoading };
};
